import Link from 'next/link';
import React from 'react';

const ClerkFormTermsAndPrivacyFooter = () => {
  return (
    <div className='flex flex-col items-center justify-center p-8'>
      <p className='text-center text-xs text-gray-400'>
        By continuing, you agree to our{' '}
        <Link href='https://getpoppy.ai/terms-conditions' className='text-gray-500'>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href='https://getpoppy.ai/privacy-policy' className='text-gray-500'>
          Privacy Policy
        </Link>
      </p>
    </div>
  );
};

export default ClerkFormTermsAndPrivacyFooter;
